import Reflux from 'reflux';

export default Reflux.createActions(['success', 'saved', 'failure', 'copied']);
